import React from 'react'
import { useIntl } from 'react-intl'
import { Panel, Flex, Text, TEXT_VARIANT_BOLD } from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useRecoilValue } from 'recoil'
import { senderInfoState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'

const BoxSenderInfo = ({ idMessage }) => {
  const intl = useIntl()
  const {
    senderName,
    senderEmail,
    replyToEmail,
    customSender,
    customEmailLabel,
    customNameLabel
  } = useRecoilValue(senderInfoState)

  return (
    <>
      <Panel>
        <Flex flexDirection='column' rowGap='8px'>
          <Flex flexDirection='row' columnGap='24px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {customSender
                ? `${intl.formatMessage({
                    id: 'Load.EmailSendingWizard.CustomSenderEmailLabel'
                  })}: `
                : `${intl.formatMessage({
                    id: 'Load.HeaderSummary.SenderEmailLabel'
                  })}: `}
            </Text>
            <Text htmlElement='span'>
              {customSender ? customEmailLabel : senderEmail}
            </Text>
            <Text htmlElement='span'>
              {customSender &&
                `${intl.formatMessage({
                  id: 'Load.HeaderSummary.CustomFieldDesc'
                })}: `}
            </Text>
          </Flex>
          <Flex flexDirection='row' columnGap='24px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {customSender
                ? `${intl.formatMessage({
                    id: 'Load.EmailSendingWizard.CustomSenderNameLabel'
                  })}: `
                : `${intl.formatMessage({
                    id: 'Load.HeaderSummary.SenderNameLabel'
                  })}: `}
            </Text>
            <Text htmlElement='span'>
              {customSender ? customNameLabel : senderName}
            </Text>
            <Text htmlElement='span'>
              {customSender &&
                `${intl.formatMessage({
                  id: 'Load.HeaderSummary.CustomFieldDesc'
                })}: `}
            </Text>
          </Flex>
          <Flex flexDirection='row' columnGap='24px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {`${intl.formatMessage({
                id: 'Load.Common.ReplyToEmailLabel'
              })}: `}
            </Text>
            <Text htmlElement='span'>{replyToEmail}</Text>
          </Flex>
        </Flex>
      </Panel>
    </>
  )
}

BoxSenderInfo.propTypes = {
  idMessage: PropTypes.number
}

export default BoxSenderInfo
